export const conditions = [
    { "id": "0", "value": "None" },
    { "id": "1", "value": "Phá vỡ XU HƯỚNG" },
    { "id": "2", "value": "Phá vỡ KHÁNG CỰ - HỖ TRỢ" },
    { "id": "3", "value": "Có nến bao trùm" }
]
